<div class="app">

  <lib-header
    [home]="homeUrl"
    [settings]="settingsUrl"
    [profile]="profileUrl"
    [external]="true"
    [ollie]="ollieUrl"
  ></lib-header>

  <div class="main">
    <router-outlet></router-outlet>
  </div>

</div>
<lib-consent-banner></lib-consent-banner>
